import { render } from "./WaMessageClient.vue?vue&type=template&id=5f413484"
import script from "./WaMessageClient.vue?vue&type=script&lang=js"
export * from "./WaMessageClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__